import React from 'react';
import './styles.css';

/**
 * 卡片组件
 * 
 * @param {Object} props - 组件属性
 * @param {string} props.title - 卡片标题
 * @param {string} props.variant - 卡片变体 (primary, secondary, success, danger, warning, info)
 * @param {boolean} props.borderless - 是否无边框
 * @param {boolean} props.compact - 是否使用紧凑型样式
 * @param {React.ReactNode} props.footer - 卡片底部内容
 * @param {string} props.className - 额外的CSS类名
 * @param {React.ReactNode} props.children - 子元素
 * @returns {JSX.Element} 卡片组件
 */
function Card({
    title,
    variant,
    borderless = false,
    compact = false,
    footer,
    className = '',
    children,
    ...rest
}) {
    // 构建卡片类名
    const cardClasses = [
        'card',
        variant ? `card-${variant}` : '',
        borderless ? 'card-borderless' : '',
        compact ? 'card-compact' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <div className={cardClasses} {...rest}>
            {title && (
                <div className="card-header">
                    <h3 className="card-title">{title}</h3>
                </div>
            )}
            <div className="card-body">
                {children}
            </div>
            {footer && (
                <div className="card-footer">
                    {footer}
                </div>
            )}
        </div>
    );
}

export default Card; 